"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const local_storage_fallback_1 = __importDefault(require("local-storage-fallback"));
const TOKEN_CONTAINER = 'TOKEN_CONTAINER';
const LAST_USED = 'LAST_USED';
const FALLBACK = 'FALLBACK';
class TokenStorage {
    constructor() {
        this.fallback = null;
        this.storage = local_storage_fallback_1.default;
        this.readFromStorage();
    }
    getDefaultToken() {
        const guid = this.lastUsed[0];
        if (!guid) {
            return;
        }
        const token = this.container[guid];
        return token;
    }
    getTokenForCompany(guid) {
        const token = this.container[guid];
        if (token) {
            this.updateLastUsed(guid);
        }
        return token;
    }
    setTokenForCompany(token) {
        this.container[token.company_id] = token;
        this.updateLastUsed(token.company_id);
        this.writeToStorage();
    }
    setFallbackToken(company_id) {
        this.fallback = company_id;
        this.writeToStorage();
    }
    getFallbackToken() {
        if (!this.fallback) {
            return;
        }
        return this.getTokenForCompany(this.fallback);
    }
    removeToken(guid) {
        delete this.container[guid];
        this.removeLastUsed(guid);
        this.writeToStorage();
    }
    removeAllTokens() {
        this.storage.removeItem(TOKEN_CONTAINER);
        this.storage.removeItem(LAST_USED);
        this.readFromStorage();
    }
    readFromStorage() {
        try {
            // Read container from storage
            const rawContainer = this.storage.getItem(TOKEN_CONTAINER);
            this.container = rawContainer ? JSON.parse(rawContainer) : {};
            // Read last used from storage
            const lastUsed = this.storage.getItem(LAST_USED);
            this.lastUsed = lastUsed ? JSON.parse(lastUsed) : [];
            this.fallback = this.storage.getItem(FALLBACK);
        }
        catch (e) {
            this.storage.clear();
            this.container = {};
            this.lastUsed = [];
        }
    }
    writeToStorage() {
        // Write token container
        this.storage.setItem(TOKEN_CONTAINER, JSON.stringify(this.container));
        // Write last used
        this.storage.setItem(LAST_USED, JSON.stringify(this.lastUsed));
        // Write fallback token
        this.storage.setItem(FALLBACK, this.fallback || "");
    }
    removeLastUsed(guid) {
        if (this.lastUsed && this.lastUsed.indexOf(guid) > -1) {
            const index = this.lastUsed.indexOf(guid);
            this.lastUsed.splice(index, 1);
        }
    }
    updateLastUsed(guid) {
        this.removeLastUsed(guid);
        this.lastUsed.unshift(guid);
    }
}
exports.default = TokenStorage;
//# sourceMappingURL=storage.js.map